import { render, staticRenderFns } from "./FavoriteBbsItem.vue?vue&type=template&id=89333a96"
import script from "./FavoriteBbsItem.vue?vue&type=script&lang=js"
export * from "./FavoriteBbsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports